import { useDayjs } from '@/composables';

const formatShortDate = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY');
};

const formatSlashDate = dateString => {
  if (!dateString) return null;
  const dayJs = useDayjs();
  return dayJs(dateString).format('DD/MM/YYYY');
};

const formatShortDateAndTime = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY [at] HH:mm A');
};

const formatFromNow = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).fromNow();
};

const formatToISO = dateString => {
  const dayJs = useDayjs();

  if (dateString) {
    return dayJs().toISOString();
  }

  return dayJs(dateString).toISOString();
};

export const useDateFormatter = () => {
  return {
    formatShortDate,
    formatSlashDate,
    formatFromNow,
    formatShortDateAndTime,
    formatToISO,
  };
};
